module.exports = __webpack_public_path__ + "assets/qr-code-frame.0dc66960.svg";